import { useProfileStore } from '@entities/viewer'

interface LessonPrivilegesReturn {
  canManageBookings: ComputedRef<boolean>
  canManageDemoBookings: ComputedRef<boolean>
  canViewTutorsSchedule: ComputedRef<boolean>
  canDeleteBookings: ComputedRef<boolean>
  canViewPaidBookings: ComputedRef<boolean>
  canCreateRecurring: ComputedRef<boolean>
}

export const useLessonPrivileges = (): LessonPrivilegesReturn => {
  const profileStore = useProfileStore()

  const hasPrivilege = (key: string): ComputedRef<boolean> =>
    computed<boolean>(() => profileStore.privileges?.includes(key) ?? false)

  return {
    canManageBookings: hasPrivilege('manage-bookings'),
    canManageDemoBookings: hasPrivilege('manage-demo-bookings'),
    canViewTutorsSchedule: hasPrivilege('view-tutors-schedule'),
    canDeleteBookings: hasPrivilege('delete-bookings'),
    canViewPaidBookings: hasPrivilege('view-paid-bookings'),
    canCreateRecurring: hasPrivilege('create-recurring-event'),
  }
}
